// Arabisch (ar), virtualDevice: zelfde vorm als virtualDevice.nl.ts (golf 3-integratie).
export const appVirtualDeviceAr = {
    title: 'iPad افتراضي',
    intro: 'لوحة العائلة الحقيقية، تمامًا كما على الجهاز اللوحي المعلّق على الحائط.',
    entry: 'iPad افتراضي',
    entryBody: 'اللوحة في متصفحك، للمشاهدة والتجربة.',
    orientation: 'الاتجاه',
    landscape: 'أفقي',
    portrait: 'عمودي',
    zoom: 'الحجم',
    fit: 'ملاءمة',
    actual: '100%',
    profile: 'جهاز',
    roomEveryone: '{room}، الجميع',
    roomMembers: '{room}، {names}',
    ownWindow: 'نافذة مستقلة',
    ownWindowLabel: 'افتح الـ iPad الافتراضي في نافذة مستقلة بحجم 1024 × 768',
    pairTitle: 'اربط هذا الـ iPad الافتراضي',
    pairBody: 'يصبح جهازًا لوحيًا مستقلًا في عائلتك. تجده بعد ذلك في الأجهزة اللوحية ويمكنك فكّ ربطه من هناك.',
    pairButton: 'ربط',
    pairWaiting: 'اللوحة تنشئ رمز ربط…',
    pairedToast: 'رُبط الـ iPad الافتراضي',
    status: '{name} في {room}',
    moved: 'تعرض اللوحة الآن جهاز {room}',
    revoke: 'فك الربط',
    revokeTitle: 'فك ربط الـ iPad الافتراضي؟',
    revokeBody: 'بعدها تعرض اللوحة في متصفحك رمز ربط من جديد. أجهزتك اللوحية الحقيقية لا تتأثر بذلك.',
    revoked: 'فُكّ ربط الـ iPad الافتراضي',
    hint: 'كل نقرة هي لمسة. الصوت والقراءة بصوت عالٍ يعملان بعد نقرتك الأولى على اللوحة، كما على الـ iPad.',
    storageTitle: 'هذا المتصفح لا يحتفظ بالربط داخل الصفحة',
    storageBody: 'بعض المتصفحات (غالبًا Safari) تحفظ اللوحة المضمّنة بشكل منفصل. افتح الـ iPad في نافذة مستقلة: هناك يبقى مربوطًا.',
    popupBlocked: 'منع متصفحك النافذة. اسمح بالنوافذ المنبثقة لهذا الموقع وحاول مرة أخرى.',
    frameTitle: 'لوحة العائلة على الـ iPad الافتراضي',
    foreignTitle: 'هذه اللوحة مربوطة باسم {name}، كجهاز لوحي عادي',
    foreignBody: 'فتحت اللوحة سابقًا مباشرة في هذا المتصفح. اربطها من جديد كـ iPad افتراضي: عندها يُفكّ ربط {name}.',
    foreignButton: 'ربط من جديد كـ iPad افتراضي',
    foreignOtherTitle: 'هذه اللوحة تخص عائلة أخرى',
    foreignOtherBody: 'هذا المتصفح مربوط كجهاز لوحي لعائلة أخرى. فكّ ربطه هناك في الأجهزة اللوحية، أو افتح هذه الصفحة في نافذة خاصة.',
    foreignStatus: '{name} في {room} (جهاز لوحي عادي)',
    stuckTitle: 'اللوحة لا تستجيب',
    stuckBody: 'أعد تحميل اللوحة. إن بقيت فارغة، فافتحها في نافذة مستقلة.',
    stuckReload: 'إعادة التحميل',
    tag: 'افتراضي',
    openOnDevice: 'فتح',
};
//# sourceMappingURL=virtualDevice.ar.js.map